'use client';

import { PageWaitlistLandingPageSchema } from '@/sanity/pages/PageWaitlistLandingPageTemplate';
import Hero from '../pageComponents/waitlist/Hero';
import Logo from '../global/Logo';
import Link from 'next/link';
import Discover from '../pageComponents/waitlist/Discover';
import Philosophy from '../pageComponents/waitlist/Philosophy';
import CommonQuestions from '../pageComponents/waitlist/CommonQuestions';
import ValueThroughVeylor from '../pageComponents/waitlist/ValueThroughVeylor';
import WaitinglistForm from '../pageComponents/waitlist/WaitinglistForm';
import AboutThePrinceptor from '../pageComponents/waitlist/AboutThePrinceptor';
import FAQSection from '../pageComponents/global/FAQSection';
import Footer from '../global/partials/Footer';
import { CTAButton } from '@/shadcn/ui/button';

export default function PageWaitlistLandingPageJSX({
  data,
}: {
  data: PageWaitlistLandingPageSchema;
}) {
  // Note: page_view / Active on Site is automatically tracked by Klaviyo script
  // No need to manually track it - would create duplicates
  // The script handles anonymous tracking and automatic merge on identification

  return (
    <main>
      <header className="absolute top-[6rem] lg:top-[4.87rem] w-full z-50">
        <div className="container flex flex-col lg:items-start items-center">
          <Link className="block" href="/" aria-label="Veylor">
            <Logo className="w-[9.64275rem] lg:w-[13.5rem]" />
          </Link>
        </div>
      </header>

      <Hero
        enableCountdown={data?.enableCountdown}
        title={data?.hero?.title}
        countdownTitle={data?.hero?.countdownTitle}
        numberOfPieces={data?.hero?.numberOfPieces}
        countdownDescription={data?.hero?.countdownDescription}
        countdownTime={data?.hero?.countdownTime}
        buttonOne={data?.hero?.buttonOne}
        buttonTwo={data?.hero?.buttonTwo}
        useVideo={data?.hero?.useVideo}
        backgroundVideo={data?.hero?.backgroundVideo}
        backgroundVideoMobile={data?.hero?.backgroundVideoMobile}
      />

      <Discover
        label={data?.discover?.label}
        title={data?.discover?.title}
        description={data?.discover?.description}
        webButton={data?.discover?.webButton}
        image={data?.discover?.image}
      />

      <div className="relative pb-[3rem] lg:pb-0">
        <Philosophy
          label={data?.philosophy?.label}
          name={data?.philosophy?.name}
          title={data?.philosophy?.title}
          description={data?.philosophy?.description}
          image={data?.philosophy?.image}
          button={data?.philosophy?.button}
        />

        <CommonQuestions
          label={data?.commonQuestions?.label}
          title={data?.commonQuestions?.title}
          button={data?.commonQuestions?.button}
          image={data?.commonQuestions?.image}
          questionOne={data?.commonQuestions?.questionOne}
          questionTwo={data?.commonQuestions?.questionTwo}
          questionThree={data?.commonQuestions?.questionThree}
        />

        <div className="lg:hidden h-0 overflow-visible sticky bottom-[12rem] left-0 right-0 z-40 px-[2rem] pointer-events-none translate-y-[-8rem]">
          <div className="pointer-events-auto">
            {data?.discover?.mobileButton && (
              <CTAButton data={data?.discover?.mobileButton} />
            )}
          </div>
        </div>
      </div>

      <ValueThroughVeylor
        title={data?.valueThroughVeylor?.title}
        mobileButton={data?.valueThroughVeylor?.mobileButton}
      />

      <WaitinglistForm
        title={data?.waitingList?.title}
        image={data?.waitingList?.image}
        form={data?.waitingList?.form}
        countdownTime={data?.hero?.countdownTime}
        enableCountdown={data?.enableCountdown}
      />

      <AboutThePrinceptor
        title={data?.aboutThePrinceptor?.title}
        cards={data?.aboutThePrinceptor?.cards}
      />

      <FAQSection title={data?.faq?.title} faqs={data?.faq?.faqs} />

      {data?.settings?.footer && <Footer data={data?.settings?.footer} />}
    </main>
  );
}
